let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8T9Il")).then(() => parcelRequire('1GO0Q'));